import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import "../styles/sifaris.css";

const WA = {
    dark: "#075E54",
    main: "#128C7E",
    bg: "#f0efeeff",
    white: "#FFFFFF",
    text: "#111827",
    border: "#C8D5CF",
};

const AppModal = ({
    open,
    title = "Diqqət",
    message = "",
    type = "info",
    buttonText = "Bağla",
    onClose,
    actions,
}) => {
    if (!open) return null;

    return (
        <div className="sq-modal-overlay">
            <div className="sq-alert-modal">
                <button className="sq-close-btn" onClick={onClose} type="button">
                    <IoClose size={22} />
                </button>

                <h3 className={`sq-alert-title sq-alert-${type}`}>{title}</h3>
                <p className="sq-alert-message">{message}</p>

                {actions?.length ? (
                    <div className="sq-alert-actions">
                        {actions.map((action, index) => (
                            <button
                                key={index}
                                type="button"
                                className={`sq-alert-button ${action.variant === "secondary"
                                        ? "sq-alert-button-secondary"
                                        : ""
                                    }`}
                                onClick={action.onClick}
                            >
                                {action.label}
                            </button>
                        ))}
                    </div>
                ) : (
                    <button className="sq-alert-button" onClick={onClose} type="button">
                        {buttonText}
                    </button>
                )}
            </div>
        </div>
    );
};

const formatPhoneNumberForWhatsApp = (phone) => {
    const digits = (phone || "").replace(/\D/g, "");

    if (/^0\d{9}$/.test(digits)) {
        return `994${digits.slice(1)}`;
    }

    if (/^994\d{9}$/.test(digits)) {
        return digits;
    }

    return null;
};

const ForgotPasswordScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [phone, setPhone] = useState("");

    const [modalOpen, setModalOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        title: "",
        message: "",
        type: "info",
        buttonText: "Bağla",
        actions: null,
    });

    useEffect(() => {
        const initialPhone = location?.state?.initialPhone;
        if (initialPhone) {
            setPhone(initialPhone);
        }
    }, [location?.state]);

    const showModal = ({
        title = "Diqqət",
        message = "",
        type = "info",
        buttonText = "Bağla",
        actions = null,
    }) => {
        setModalConfig({ title, message, type, buttonText, actions });
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const handleContactAdmin = () => {
        if (!phone) {
            showModal({
                title: "Diqqət",
                message: "Zəhmət olmasa telefon nömrənizi daxil edin.",
                type: "warning",
            });
            return;
        }

        const phoneDigits = phone.replace(/\D/g, "");

        if (!/^0\d{9}$/.test(phoneDigits)) {
            showModal({
                title: "Diqqət",
                message: "Telefon nömrəsini bu formatda daxil edin: 0XXYYYYYYY",
                type: "warning",
            });
            return;
        }

        const adminPhoneNumber = "0709559984";
        const formattedPhoneNumber = formatPhoneNumberForWhatsApp(adminPhoneNumber);

        if (!formattedPhoneNumber) {
            showModal({
                title: "Xəta",
                message: "Admin nömrəsi düzgün formatda deyil.",
                type: "error",
            });
            return;
        }

        const message =
            `Salam. Mən Sifariş Qrupu saytında şifrəmi unutdum. Zəhmət olmasa kömək edin.\n` +
            `Telefon nomrem: ${phoneDigits}`;

        const whatsappUrl = `https://wa.me/${formattedPhoneNumber}?text=${encodeURIComponent(
            message
        )}`;

        window.open(whatsappUrl, "_blank");
    };

    return (
        <>
            <div
                className="sq-page"
                style={{
                    backgroundColor: WA.bg,
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                }}
            >
                <div className="sq-card">
                    <h1 className="sq-title">Şifrəmi unutdum</h1>

                    <p className="sq-subtitle">
                        Zəhmət olmasa telefon nömrənizi yazın və adminlə əlaqə saxlayın.
                    </p>

                    <input
                        className="sq-input"
                        placeholder="Telefon nömrəsi: 0XXYYYYYYY"
                        value={phone}
                        maxLength={10}
                        inputMode="numeric"
                        onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ""))}
                    />

                    <button
                        className="sq-primary-btn"
                        onClick={handleContactAdmin}
                        type="button"
                    >
                        Adminlə əlaqə saxla
                    </button>

                    <button
                        type="button"
                        className="sq-register-link"
                        onClick={() => navigate(-1)}
                    >
                        Geri
                    </button>
                </div>
            </div>

            <AppModal
                open={modalOpen}
                title={modalConfig.title}
                message={modalConfig.message}
                type={modalConfig.type}
                buttonText={modalConfig.buttonText}
                actions={modalConfig.actions}
                onClose={closeModal}
            />
        </>
    );
};

export default ForgotPasswordScreen;